// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__FZR7k","label":"Section_label__1Vy_Y","contentWrap":"Section_contentWrap__1IEV5","footer":"Section_footer__2iynz","footerInner":"Section_footerInner__zq019"};